import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import "../styles/SpeechControls.css";

const SpeechControls = ({ text }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [voices, setVoices] = useState([]);

  useEffect(() => {
    window.speechSynthesis.cancel();
  }, []);

  useEffect(() => {
    const loadVoices = () => {
      const allVoices = speechSynthesis.getVoices();
      if (allVoices.length > 0) {
        setVoices(allVoices);
      }
    };

    loadVoices();
    speechSynthesis.onvoiceschanged = loadVoices;
  }, []);

  const getFemaleVoice = () => {
    return (
      voices.find(
        (v) =>
          v.name.toLowerCase().includes("female") ||
          v.name.toLowerCase().includes("zira") ||
          v.name.toLowerCase().includes("google us")
      ) || voices[0]
    );
  };

  const handleSpeak = () => {
    if (isSpeaking) {
      speechSynthesis.cancel();
      setIsSpeaking(false);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = getFemaleVoice();
    utterance.lang = "en-US";
    utterance.rate = 1;
    utterance.onend = () => setIsSpeaking(false);

    setIsSpeaking(true);
    speechSynthesis.cancel(); // cancel any pending speech
    speechSynthesis.speak(utterance);
  };

  return (
    <IconButton onClick={handleSpeak} style={{ color: "#fff" }}>
      {isSpeaking ? (
        <VolumeUpIcon fontSize="small" className="wave" />
      ) : (
        <VolumeOffIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default SpeechControls;
